import {
  usePerformanceProFilterOptions,
  usePerformanceProFilterOptionsActions,
} from "../../store/GlobalContext";
import {
  canStepForward,
  DatePeriod,
  getNavigationStep,
  NavigationStep,
  stepDate,
  validateIfDateOrReturnToday,
} from "../../utility/DateUtility";
import { selectedDateKey } from "../../utility/LocalStorageKeys";
import { t } from "../../utility/TranslateUtility";

const stepLabelKeys: Record<NavigationStep, { previous: string; next: string }> =
  {
    [DatePeriod.Day]: {
      previous: "toolbarDateNavigation.previousDay",
      next: "toolbarDateNavigation.nextDay",
    },
    [DatePeriod.Week]: {
      previous: "toolbarDateNavigation.previousWeek",
      next: "toolbarDateNavigation.nextWeek",
    },
    [DatePeriod.Month]: {
      previous: "toolbarDateNavigation.previousMonth",
      next: "toolbarDateNavigation.nextMonth",
    },
    [DatePeriod.Year]: {
      previous: "toolbarDateNavigation.previousYear",
      next: "toolbarDateNavigation.nextYear",
    },
  };

export interface PerformanceProDateNavigation {
  selectedDate: Date;
  canGoNext: boolean;
  previousLabel: string;
  nextLabel: string;
  onDateChange: (newDate: Date) => void;
  onPrevious: () => void;
  onNext: () => void;
}

export function usePerformanceProDateNavigation(
  enableDatePeriod: boolean
): PerformanceProDateNavigation {
  const performanceProFilterOptions = usePerformanceProFilterOptions();
  const dispatch = usePerformanceProFilterOptionsActions();

  const selectedDate = validateIfDateOrReturnToday(
    performanceProFilterOptions.selectedDate
  );
  const step = getNavigationStep(
    performanceProFilterOptions.selectedDatePeriod,
    enableDatePeriod
  );

  const onDateChange = (newDate: Date) => {
    localStorage.setItem(selectedDateKey, newDate.toString());
    dispatch({
      ...performanceProFilterOptions,
      selectedDate: newDate,
    });
  };

  return {
    selectedDate,
    canGoNext: canStepForward(selectedDate, step),
    previousLabel: t(stepLabelKeys[step].previous),
    nextLabel: t(stepLabelKeys[step].next),
    onDateChange,
    onPrevious: () => onDateChange(stepDate(selectedDate, step, -1)),
    onNext: () => onDateChange(stepDate(selectedDate, step, 1)),
  };
}
